// Module
var code = "<react-component name=\"ActiveContacts\"></react-component>\n";
// Exports
module.exports = code;